import {
  EXAMPLE_ID, EXAMPLE_BRIEF, EXAMPLE_REPLY, EXAMPLE_NAME, EXAMPLE_FLOW_JSON,
} from './exampleFlow';
import { PLUMBER_QUOTE } from './examples/plumberQuote';
import { DENTAL_REGISTRATION } from './examples/dentalRegistration';
import { VIEWING_BOOKING } from './examples/viewingBooking';
import { GARAGE_BOOKING } from './examples/garageBooking';

/**
 * Every worked example the landing page can hand straight to the builder.
 *
 * A suggestion chip is not a brief somebody wrote, it is "show me one of those", so it is
 * answered with something prepared: instantly, at no cost, and the same every time. Only words
 * the visitor typed themselves are worth a real build, which takes six to twenty-six seconds and
 * costs money to produce.
 *
 * Until 2026-09-23 exactly one chip had an example behind it and the other two went through the
 * full generation, so two of the three suggestions were slower, dearer and less predictable than
 * the one beside them for no reason a visitor could see.
 */
export const EXAMPLES = {
  [EXAMPLE_ID]: {
    id: EXAMPLE_ID,
    brief: EXAMPLE_BRIEF,
    reply: EXAMPLE_REPLY,
    name: EXAMPLE_NAME,
    flowJson: EXAMPLE_FLOW_JSON,
  },
  [PLUMBER_QUOTE.id]: PLUMBER_QUOTE,
  [DENTAL_REGISTRATION.id]: DENTAL_REGISTRATION,
  [VIEWING_BOOKING.id]: VIEWING_BOOKING,
  [GARAGE_BOOKING.id]: GARAGE_BOOKING,
};

/** The one the hero falls back to, and the only one carrying a picture. */
export const DEFAULT_EXAMPLE_ID = EXAMPLE_ID;

/** @returns the example, or null when the id is not one this build knows. */
export const exampleFor = (id) => EXAMPLES[id] || null;
